(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ashperoo-product-share')) {
    customElements.define('ashperoo-product-share', class extends HTMLElement {
      connectedCallback() {
        if (this.psController) return;
        this.psController = new AbortController();
        const signal = this.psController.signal;
        this.psButton = this.querySelector('[data-share-open]');
        this.psDialog = this.querySelector('dialog');
        this.psButton.addEventListener('click', () => this.psShare(), { signal });
        this.querySelector('[data-share-close]').addEventListener('click', () => this.psDialog.close(), { signal });
        this.querySelector('[data-share-copy]').addEventListener('click', () => this.psCopy(), { signal });
        this.psDialog.addEventListener('close', () => {
          this.psUnlock();
          if (this.psButton.isConnected) this.psButton.focus();
        }, { signal });
        this.psDialog.addEventListener('click', (event) => {
          if (event.target !== this.psDialog) return;
          const rect = this.psDialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.psDialog.close();
        }, { signal });
      }
      psData() {
        return { title: this.dataset.shareTitle || document.title, url: new URL(this.dataset.shareUrl || location.href, location.origin).href };
      }
      async psShare() {
        if (this.psBusy) return;
        this.psBusy = true;
        const data = this.psData();
        try {
          if (this.dataset.nativeShare === 'true' && navigator.share && (!navigator.canShare || navigator.canShare(data))) {
            try {
              await navigator.share(data);
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          if (this.isConnected) this.psOpen(data);
        } finally { this.psBusy = false; }
      }
      psOpen(data) {
        const url = encodeURIComponent(data.url);
        const message = encodeURIComponent(data.title + ' ' + data.url);
        this.querySelector('[data-share-platform="whatsapp"]').href = 'https://wa.me/?text=' + message;
        this.querySelector('[data-share-platform="facebook"]').href = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
        this.querySelector('[data-share-platform="x"]').href = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + encodeURIComponent(data.title);
        this.querySelector('[data-share-url-input]').value = data.url;
        this.querySelector('[data-share-status]').textContent = '';
        if (!this.psDialog.open) {
          this.psDialog.showModal();
          this.psOldOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }
      }
      async psCopy() {
        const input = this.querySelector('[data-share-url-input]');
        const status = this.querySelector('[data-share-status]');
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(input.value);
          status.textContent = this.dataset.copied;
        } catch (_) {
          input.focus(); input.select();
          status.textContent = this.dataset.copyFailed;
        }
      }
      psUnlock() {
        if (this.psOldOverflow !== undefined) {
          document.documentElement.style.overflow = this.psOldOverflow;
          this.psOldOverflow = undefined;
        }
      }
      disconnectedCallback() {
        if (this.psDialog?.open) this.psDialog.close();
        this.psUnlock();
        this.psController?.abort();
        this.psController = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
